// Unified environment accessor for CRA (process.env.REACT_APP_*) and Vite (import.meta.env.VITE_*)
export function getEnv(name, fallback) {
  try {
    const proc =
      typeof process !== 'undefined'
        ? process
        : typeof globalThis !== 'undefined'
          ? globalThis.process
          : undefined
    const env = proc && typeof proc === 'object' ? proc.env : undefined

    if (env && env[name] != null) {
      return env[name]
    }
  } catch (_) {}

  // Map REACT_APP_FOO -> VITE_FOO for Vite
  const viteKey = name.startsWith('REACT_APP_') ? `VITE_${name.slice('REACT_APP_'.length)}` : name
  try {
    // Vite exposes import.meta.env in the browser; avoid referencing `import` directly
    // eslint-disable-next-line no-undef
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[viteKey] != null) {
      // eslint-disable-next-line no-undef
      return import.meta.env[viteKey]
    }
  } catch (_) {}

  return fallback
}
